import { buildPresignMedia as e, createProgressAggregator as t, matchUploadsToFiles as n, partitionUploadable as r } from "./mediaUploadPlan.mjs";
import { DirectUploadError as i, postDirectUpload as a, uploadWithConcurrency as o } from "@maat/api-base";
import { MEDIA_UPLOAD_MAX_BYTES as s } from "@maat/api-main/types";
//#region src/properties/media/runPropertyMediaUpload.ts
var c = 4, l = (e) => {
	let t = e instanceof i ? e.status : void 0;
	return t === void 0 || t >= 500;
}, u = async ({ propertyId: u, groups: d, presign: f, carriesEdits: p = !1, onUploadProgress: m }) => {
	let { accepted: h, skipped: g } = r(d, s);
	if (h.length === 0 && !p) return {
		propertyId: u,
		uploaded: 0,
		skipped: g,
		failed: []
	};
	let { matched: _, unattributed: v } = n((await f(e(h))).uploads, h), y = t(_.reduce((e, t) => e + t.file.size, 0), m), b = [];
	await o(_, c, async (e, t) => {
		let n = () => a({
			url: e.upload.url,
			fields: e.upload.fields,
			file: e.file,
			onProgress: (e) => y.onFileProgress(t, e.loaded)
		});
		try {
			try {
				await n();
			} catch (e) {
				if (!l(e)) throw e;
				await n();
			}
			y.onFileSettled(t, e.file.size);
		} catch (t) {
			b.push({
				category: e.category,
				name: e.file.name,
				status: t instanceof i ? t.status : void 0
			});
		}
	});
	let x = _.length - b.length;
	if (x === 0 && _.length > 0) throw Error("None of the selected photos could be uploaded.");
	return {
		propertyId: u,
		uploaded: x,
		skipped: [...g, ...v],
		failed: b
	};
};
//#endregion
export { u as runPropertyMediaUpload };
